export const SPOTIFY_FOLLOWED_ARTISTS_CHUNK_SIZE = 50;
export const SPOTIFY_FOLLOWED_ARTISTS_DELETE_CHUNK_SIZE = 50;
